export default "__VITE_ASSET__BnnhizSA__"